"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.Text = void 0;
var _react = _interopRequireDefault(require("react"));
var _FormattedComposite = _interopRequireDefault(require("../FormattedComposite/FormattedComposite"));
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-props-no-spreading */

/**
 * Primary UI component for text
 */
const Text = ({
  type,
  content,
  isHTML,
  className,
  data,
  ...props
}) => {
  const {
    children,
    ...rest
  } = props;
  if (data) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: ['ccl__text', type ? `ccl__text--${type}` : '', className].join(' '),
      ...rest,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedComposite.default, {
        config: {
          format: content != null ? content : children,
          type: 'composite'
        },
        data: data
      })
    });
  } else if (isHTML) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: ['ccl__text', type ? `ccl__text--${type}` : '', className].join(' '),
      ...rest,
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML: {
        __html: content != null ? content : children
      }
    });
  } else {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: ['ccl__text', type ? `ccl__text--${type}` : '', className].join(' '),
      ...rest,
      children: content != null ? content : children
    });
  }
};
exports.Text = Text;
Text.defaultProps = {
  type: '',
  isHTML: false,
  className: ''
};